function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import Popover from 'researcher/components/Popover';
import { STATUSES } from 'researcher/digital-editing/constants';
import featureEnabled from 'shared/helper/feature';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import { trackAbstractGenerationFailed } from 'researcher/helpers/abstractMixpanelEvents';
import { formatForLocale, formatAsTimeAgo } from '../helpers/date';
import { RUBRIQ_LEWIS_VERSION_MAP, NUMBER_OF_SECONDS_BETWEEN_DOCUMENT_CREATION_DATE_TEXT_UPDATES, RUBRIQ_PLAN_NAMES_MAP, RUBRIQ_LANGUAGE_LABELS } from '../constants';
var RubriqDocumentCardStatus = function RubriqDocumentCardStatus(_ref) {
  var _document$file;
  var document = _ref.document,
    _ref$documentType = _ref.documentType,
    documentType = _ref$documentType === void 0 ? 'editing' : _ref$documentType;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    creationDateText = _useState2[0],
    setCreationDateText = _useState2[1];
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    digitalEdit = _useSelector.digitalEdit,
    digitalOrders = _useSelector.digitalOrders;
  var _useSelector2 = useSelector(function (state) {
      return state;
    }),
    user = _useSelector2.user;
  var intervalRef = useRef(null);
  var _useSelector3 = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector3.curie;
  var processing = document.status === STATUSES.STATUS_PROCESSING;
  var failed = document.status === STATUSES.STATUS_FAILED;
  var completed = document.status === STATUSES.STATUS_COMPLETED;
  var rubriqNewLewisVersionEnabled = featureEnabled('rubriq_lewis_version');
  var facEnabled = featureEnabled('rubriq_FAC_Api_for_translation');
  var tooltipMessage = facEnabled ? 'unknown-error-translation-deepseek-card-tooltip' : 'unknown-error-translation-card-tooltip';
  var isTranslation = documentType === 'translation';
  var isAbstract = documentType === 'abstract';
  var translationStatus = facEnabled ? /*#__PURE__*/React.createElement(T, {
    source: "rubriq.failed"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "unknown-error-translation-card-title"
  });
  var STATUS_LABEL_BY_TYPE = {
    translation: 'translated',
    abstract: 'generated',
    editing: 'edited'
  };
  var fromWordAddin = !isTranslation && document.origin === 'wai';
  var fileName = ((_document$file = document.file) === null || _document$file === void 0 ? void 0 : _document$file.name) || null;
  var fileType = fileName ? fileName.split('.').pop() : null;
  var editingLatexTooltip = fileType === 'tex' ? 'rubriq.completed-latex-editing-tooltip' : 'curie.completed-editing-tooltip';
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var prevStatusMapRef = useRef({});
  useEffect(function () {
    var updateDateText = function updateDateText() {
      if (isAbstract) {
        setCreationDateText(formatForLocale(document.createdAt, t));
      } else {
        setCreationDateText(formatAsTimeAgo(document.createdAt, t));
      }
    };
    updateDateText();
    intervalRef.current = setInterval(function () {
      updateDateText();
    }, NUMBER_OF_SECONDS_BETWEEN_DOCUMENT_CREATION_DATE_TEXT_UPDATES * 1000);
    return function () {
      return clearInterval(intervalRef.current);
    };
  }, [document.createdAt, isAbstract, t]);
  useEffect(function () {
    var _document$file2;
    var currentStatus = document.status;
    var docId = ((_document$file2 = document.file) === null || _document$file2 === void 0 ? void 0 : _document$file2.identity) || document.id;
    var prevStatus = prevStatusMapRef.current[docId];
    if (prevStatus === STATUSES.STATUS_PROCESSING && currentStatus === STATUSES.STATUS_COMPLETED) {
      var _file$name$split$pop, _curie$plans$premium, _curie$plans, _premium$planName, _document$file3, _file$name, _file$identity, _curie$plan$subscript, _curie$plan, _digitalEdit$digitalE, _digitalOrders$digita;
      var file = document.file || {};
      var extension = file.name ? (_file$name$split$pop = file.name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase() : null;
      var premium = (_curie$plans$premium = curie === null || curie === void 0 || (_curie$plans = curie.plans) === null || _curie$plans === void 0 ? void 0 : _curie$plans.premium) !== null && _curie$plans$premium !== void 0 ? _curie$plans$premium : {};
      var rawPlanName = (_premium$planName = premium.planName) !== null && _premium$planName !== void 0 ? _premium$planName : null;
      var formattedPlanName = RUBRIQ_PLAN_NAMES_MAP[rawPlanName] || rawPlanName;
      if ((premium === null || premium === void 0 ? void 0 : premium.paymentStatus) === 'trialing') {
        formattedPlanName = "".concat(formattedPlanName, " (Trial)");
      }
      var wordcount = ((_document$file3 = document.file) === null || _document$file3 === void 0 ? void 0 : _document$file3.calculatedWordCount) != null ? Number(document.file.calculatedWordCount) : null;
      var versionKey = RUBRIQ_LEWIS_VERSION_MAP[document.version] || null;
      var editingIntensity = versionKey ? t(versionKey) : null;
      var createdAt = document.createdAt ? new Date(document.createdAt) : null;
      var completedAt = new Date();
      var timeConsumedSeconds = createdAt ? Math.floor((completedAt - createdAt) / 1000) : null;
      var timeConsumedMins = timeConsumedSeconds != null ? Math.round(timeConsumedSeconds / 60) : null;
      var basePayload = {
        file_name: (_file$name = file.name) !== null && _file$name !== void 0 ? _file$name : null,
        file_type: extension,
        file_identity: (_file$identity = file.identity) !== null && _file$identity !== void 0 ? _file$identity : null,
        planName: formattedPlanName !== null && formattedPlanName !== void 0 ? formattedPlanName : null,
        billing_cycle: (_curie$plan$subscript = curie === null || curie === void 0 || (_curie$plan = curie.plan) === null || _curie$plan === void 0 ? void 0 : _curie$plan.subscriptionInterval) !== null && _curie$plan$subscript !== void 0 ? _curie$plan$subscript : null,
        wordcount: wordcount,
        completed_at: new Date().toISOString(),
        timeConsumedMins: timeConsumedMins,
        email: user === null || user === void 0 ? void 0 : user.email,
        user_identity: user.identity
      };
      var existingDocsCountEdit = ((_digitalEdit$digitalE = digitalEdit.digitalEdits) === null || _digitalEdit$digitalE === void 0 ? void 0 : _digitalEdit$digitalE.length) || 0;
      var totalFilesEdit = existingDocsCountEdit + 1;
      var existingDocsCountOrder = ((_digitalOrders$digita = digitalOrders.digitalOrders) === null || _digitalOrders$digita === void 0 ? void 0 : _digitalOrders$digita.length) || 0;
      var totalFilesOrder = existingDocsCountOrder + 1;
      var eventName = isTranslation ? 'Translation Completed' : 'Editing Completed';
      var languageLabel = RUBRIQ_LANGUAGE_LABELS[document.language] || document.language;
      if (!isTranslation) {
        trackRubriqEvent(eventName, _objectSpread(_objectSpread({}, basePayload), {}, {
          editingIntensity: editingIntensity || null,
          styleOfEnglish: document.styleOfEnglish || null,
          second_file_uploaded: totalFilesEdit >= 2,
          third_file_uploaded: totalFilesEdit >= 3
        }));
      } else {
        trackRubriqEvent(eventName, _objectSpread(_objectSpread({}, basePayload), {}, {
          languages: languageLabel || null,
          time_taken: document.processingTime || null,
          second_file_uploaded: totalFilesOrder >= 2,
          third_file_uploaded: totalFilesOrder >= 3
        }));
      }
    }
    if (prevStatus === STATUSES.STATUS_PROCESSING && currentStatus === STATUSES.STATUS_FAILED && isAbstract) {
      var _curie$plans$premium2, _curie$plans2, _premium$planName2, _user$identity, _premium$type;
      var _premium = (_curie$plans$premium2 = curie === null || curie === void 0 || (_curie$plans2 = curie.plans) === null || _curie$plans2 === void 0 ? void 0 : _curie$plans2.premium) !== null && _curie$plans$premium2 !== void 0 ? _curie$plans$premium2 : {};
      var _rawPlanName = (_premium$planName2 = _premium.planName) !== null && _premium$planName2 !== void 0 ? _premium$planName2 : null;
      var _formattedPlanName = RUBRIQ_PLAN_NAMES_MAP[_rawPlanName] || _rawPlanName;
      if ((_premium === null || _premium === void 0 ? void 0 : _premium.paymentStatus) === 'trialing') {
        _formattedPlanName = "".concat(_formattedPlanName, " (Trial)");
      }
      trackAbstractGenerationFailed({
        userIdentity: (_user$identity = user === null || user === void 0 ? void 0 : user.identity) !== null && _user$identity !== void 0 ? _user$identity : null,
        planType: (_premium$type = _premium === null || _premium === void 0 ? void 0 : _premium.type) !== null && _premium$type !== void 0 ? _premium$type : null,
        planName: _formattedPlanName !== null && _formattedPlanName !== void 0 ? _formattedPlanName : null,
        trialStatus: (_premium === null || _premium === void 0 ? void 0 : _premium.paymentStatus) === 'trialing' ? 'trialing' : 'none'
      });
    }
    prevStatusMapRef.current[docId] = currentStatus;
  }, [document.status, curie]);
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-nowrap text-nowrap gap-2 align-items-center rubriq-text-document-status"
  }, processing && /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }), /*#__PURE__*/React.createElement(T, {
    source: "processing"
  }), /*#__PURE__*/React.createElement(Popover, {
    content: isAbstract ? 'curie.processing-abstract-tooltip' : isTranslation ? 'curie.processing-translation-tooltip' : 'curie.processing-editing-tooltip',
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info"
  }))), failed && /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, isAbstract ? /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-failed"
  }) : isTranslation ? /*#__PURE__*/React.createElement("span", null, " ", translationStatus, " ") : /*#__PURE__*/React.createElement(T, {
    source: "unknown-error-editing-card-title"
  })), /*#__PURE__*/React.createElement(Popover, {
    content: isAbstract ? 'curie.failed-abstract-tooltip' : isTranslation ? tooltipMessage : 'unknown-error-editing-card-tooltip',
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info",
    className: "text-danger"
  }))), completed && /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-capitalize ".concat(isAbstract ? 'text-success' : '')
  }, /*#__PURE__*/React.createElement(T, {
    source: STATUS_LABEL_BY_TYPE[documentType] || 'edited'
  })), /*#__PURE__*/React.createElement(Popover, {
    content: isAbstract ? 'curie.completed-abstract-tooltip' : isTranslation ? 'curie.completed-translation-tooltip' : editingLatexTooltip,
    params: isTranslation ? {
      language: t(document.language),
      styleOfEnglish: t(document.styleOfEnglish || 'American English')
    } : document.styleOfEnglish,
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info",
    className: isAbstract ? 'text-success' : ''
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, isAbstract && completed && /*#__PURE__*/React.createElement(React.Fragment, null, document.generatedWordCount && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, document.generatedWordCount, " words")), document.abstractType && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "text-muted text-capitalize"
  }, document.abstractType))), rubriqNewLewisVersionEnabled && !isTranslation && document.styleOfEnglish && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, t(document.styleOfEnglish))), rubriqNewLewisVersionEnabled && !isTranslation && document.version && (document.version === '1.7.0' || document.version === '1.8.7') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, document.version === '1.7.0' ? /*#__PURE__*/React.createElement(T, {
    source: "rubriq.moderate-edits"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "rubriq.high-edits"
  }))), "\xB7", /*#__PURE__*/React.createElement("span", null, creationDateText, "\xA0", fromWordAddin && /*#__PURE__*/React.createElement(T, {
    source: "from word add-in"
  }))));
};
export default RubriqDocumentCardStatus;